export default __webpack_public_path__ + "ca69529a14a75cfeb47daa0f67985096.svg";